module.exports = __webpack_public_path__ + "images/category_lp/pc/reason2_c45f767c02c5b6033a4813772ea6e871.png";